// eslint-disable-next-line no-restricted-imports
import type { NotificationGroupResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { normalizeNotificationGroups } from 'app/gamma/src/api/normalizers/notification';
import { notificationsPaneState } from './notificationsPaneState';
// eslint-disable-next-line no-restricted-imports
import { sanitizeNotificationGroups } from 'app/gamma/src/modules/state/models/notifications';
import { notificationsState } from './notificationsState';
// eslint-disable-next-line no-restricted-imports
import type {
  NotificationGroupModel,
  NotificationModel,
} from 'app/gamma/src/types/models';

export const loadUnreadNotificationsSuccess = ({
  notificationGroupsResponse,
  partialUnreadNotificationGroups,
  isFilteringByUnread,
}: {
  notificationGroupsResponse: NotificationGroupResponse[];
  partialUnreadNotificationGroups: NotificationGroupModel[];
  partialUnreadNotifications: NotificationModel[];
  isFilteringByUnread: boolean;
}) => {
  const fullUnreadNotificationGroups = normalizeNotificationGroups(
    notificationGroupsResponse,
  );
  const notificationGroups = partialUnreadNotificationGroups.map((group) => {
    const fullGroup = fullUnreadNotificationGroups.find(
      (g) => g.idGroup === group.idGroup,
    );
    return {
      ...group,
      ...fullGroup,
    };
  });
  if (notificationsPaneState.value.cancelLoadingUnread) {
    notificationsPaneState.setValue({
      ...notificationsPaneState.value,
      cancelLoadingUnread: false,
    });
    // this request has been replaced by another one, and is irrelevant
  } else {
    const existingGroups = notificationsPaneState.value.notificationGroupsStale
      ? []
      : notificationsState.value.notificationGroups;
    notificationsPaneState.setValue({
      ...notificationsPaneState.value,
      notificationGroupsStale: false,
    });
    notificationsState.setValue({
      ...notificationsState.value,
      notificationGroups: sanitizeNotificationGroups(
        existingGroups,
        notificationGroups,
        isFilteringByUnread,
      ),
    });
  }
};
